import React, { Component } from 'react'
import PropTypes from 'prop-types'
// TODO: Implement keydown correctly: import keydown, { Keys } from 'react-keydown'

import { FontIcon, TextField, SelectionControlGroup, Grid, Subheader } from 'lib/react-md'

import OptionList from 'components/common/OptionList'

class FeedbackCardEdit extends Component {
	state = {
		properties: this.props.node.properties,
	};

	onChange = property => this.setState({ properties: { ...this.state.properties, ...property }});

	queryClose = () => ({ proceed: true });

	validateForm = () => {
		const { title, inputType, items } = this.state.properties;

		if (!title) return "Bitte formulieren Sie eine Frage.";
		if (!inputType) return "Bitte wählen Sie die Antwortoption aus.";
		if (['radio', 'checkbox'].includes(inputType) && (!items || items.length < 2)) {
			return "Bitte geben Sie mindestens zwei Optionen an.";
		}
		return "";
	};

	querySaveAndClose = () => {
		const { properties } = this.state;
		const error = this.validateForm();

		return !error ? { proceed: true, result: { properties } } : { proceed: false, error };
	};

	queryDelete = () => ({ proceed: true, success: "Frage gelöscht", error: "Fehler beim Löschen der Frage" });

	componentWillMount() {
		const { title } = this.state.properties;
		this.props.setTitle(title ? "Frage bearbeiten" : "Neue Frage");
	}

	render() {
		const { node } = this.props;
		const { title, inputType, items } = this.state.properties;

		return (
			<Grid>
				<TextField
					id="feedback-title"
					label="Frage"
					className="md-cell md-cell--bottom"
					defaultValue={title}
					rows={1}
					onChange={value => this.onChange({ title: value })}
				/>
				<div className="md-list-unstyled">
					<Subheader primaryText="Welche Antworten sind möglich?"/>
					<SelectionControlGroup
						id={`feedback-radio-input-${node.$id}`}
						name={`feedback-radio-input-${node.$id}`}
						type="radio"
						//inline
						controls={[
							{ label: 'Eine aus einer Liste', value: 'radio' },
							{ label: 'Mehrere aus einer Liste', value: 'checkbox' },
						  {	label: 'Frei formulierter Text', value: 'text'}
					  ]}
						value={inputType}
						checkedRadioIcon={<FontIcon>check</FontIcon>}
						uncheckedRadioIcon={<FontIcon style={{color: "#D2D2D2"}}>radio_button_unchecked</FontIcon>}
						onChange={value => this.onChange({ inputType: value })}
					/>
				</div>
				{ ['radio', 'checkbox'].includes(inputType) &&
				  <OptionList
					  items={items}
					  titleNew={"Neue Antwortoption"}
					  titleList={"Liste der Antwortoptionen"}
					  onChange={items => this.onChange({ items })}/> }
			</Grid>
		);
	}

}

FeedbackCardEdit.propTypes = {
	node: PropTypes.any.isRequired,
	setTitle: PropTypes.any.isRequired
};

export default FeedbackCardEdit;


// WEBPACK FOOTER //
// ./src/components/cards/feedback/default/FeedbackCardEdit.jsx